import { useEffect } from 'react';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';
import Layout from 'components/Layout';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const Custom500 = () => {
  useEffect(() => {
    sendEvent({ action: 'error_500', category: 'page_error_500' });
  }, []);

  return (
    <Layout withGridLayout={false}>
      <div className="mb-20 flex flex-col items-center px-4 md:px-0">
        <Image
          alt="Imagem de erro 500"
          className="mt-10 md:mt-20 md:h-[368px] md:w-[663px]"
          height={172}
          loading={null}
          src={`${APP.LOCAL_IMAGE_PATH}/error/500.svg`}
          width={311}
          priority
        />
        <Heading as="h1" className="mt-8 px-4 text-center" size="size2">
          {placeholder('titles.500')}
        </Heading>
        <Text className="mt-4 max-w-[292px] text-center md:max-w-[448px]">
          {placeholder('subtitles.500')}
          <br />
          {placeholder('subtitles.tryAgain')}
        </Text>
      </div>
    </Layout>
  );
};

export default Custom500;
